import {useNotify} from "ra-core";
import {AutocompleteArrayInput, ReferenceArrayInput, ReferenceInputProps,} from "ra-ui-materialui";
import React from "react";
import {client} from "../../dataProvider";
import {generateError} from "../../shared/utils";

type ReferenceInputSubjectProps = Omit<
  ReferenceInputProps,
  "children" | "reference" | "sort"
>;

export const ReferenceArrayInputSubject = (props: ReferenceInputSubjectProps) => {
  const notify = useNotify();
  const mustHaveProvince = async (subject_id: number | undefined) => {
    return undefined;
    if (subject_id) {
      return client(`/subjects/mustHaveProvince?ids=${subject_id}`, {
        method: "GET",
      })
        .then((response) => {
          if (response.allHaveProvince === true) {
            return undefined;
          } else {
            return "Manca la provincia di uno o più soggetti";
          }
        })
        .catch((error) => {
          generateError(error, notify);
          return "Verificare che i soggetti abbiano la provincia";
        });
    } else {
      return undefined;
    }
  };
  return (
    <ReferenceArrayInput
      {...(props as ReferenceInputProps)}
      variant="outlined"
      reference="autocomplete/subject"
      sort={{ field: "business_name", order: "ASC" }}
      allowEmpty={props.allowEmpty === false ? false : true}
      validate={mustHaveProvince}
      isRequired={props.isRequired || props.required}
    >
      <AutocompleteArrayInput
        options={{ ...props.options }}
        optionText="label"
        onCreate={(filter) =>
          window.open(
            "/subjects/create",
            "_blank" // <- This is what makes it open in a new window.
          )
        }
      />
    </ReferenceArrayInput>

  );
};
